import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MiComponent } from './dashboard/mi/mi.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CompanyComponent } from './company/company.component';
import { LayoutLoginComponent } from './_layouts/layout-login/layout-login.component';
import { LayoutInnerpagesComponent } from './_layouts/layout-innerpages/layout-innerpages.component';
import { CompanyUpsertComponent } from './company/company-upsert.component';
import { UserComponent } from './user/user.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { QuoteComponent } from './quote/quote.component';
import { QuoteListComponent } from './quote/quote-list/quote-list.component';
import { QuoteDetailsComponent } from './quote/quote-details/quote-details/quote-details.component';
import { PolicyComponent } from './policy/policy.component';
import { PolicyListComponent } from './policy/policy-list/policy-list.component';
import { BordereauComponent } from './bordereau/bordereau.component';
import { LoginGuard } from './auth/auth.guard';
import { AdminAlQuoteComponent } from './quote/alpaca/al-quote/al-quote.component';

import { AlQuoteDetailsComponent } from './quote/alpaca/quote-details/quote-details/quote-details.component';

import { AlPolicyDetailsComponent } from './policy/alpaca/policy-details/policy-details.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { QuoteEmailViewComponent } from './quote-email/quote-email-view/quote-email-view.component';
import { BordereauLiveComponent } from './bordereau/bordereau-live/bordereau-live.component';
import { BordereauLapseComponent } from './bordereau/bordereau-lapse/bordereau-lapse.component';
import { QuotePreQualifierComponent } from './quote-pre-qualifier/quote-pre-qualifier.component';

import { LivestockComponent } from './quote/livestock/livestock.component';
import { LvQuoteDetailsComponent } from './quote/livestock/quote-details/quote-details/quote-details.component';

import { LvPaymentConfirmationComponent } from './quote/livestock/lv-payment-confirmation/lv-payment-confirmation.component';
import { LivestockViewComponent } from './quote-view/livestock-view/livestock-view.component';
import { UnauthorizedAccessComponent } from './unauthorized-access/unauthorized-access.component';

import { AllianzComponent } from './quote/allianz-equine/allianz.component';
import { AllianzQuoteDetailsComponent } from './quote/allianz-equine/quote-details/quote-details/quote-details.component';

import { AllianzPolicyDetailsComponent } from './policy/allianz-equine/policy-details/policy-details.component';
import { AjgQuoteComponent } from './quote/ajg/ajg-quote.component';
import { AjgQuoteViewComponent } from './quote/ajg/quote-view/ajg-quote-view.component';
import { PolicyViewComponent } from './policy/policy-view/policy-view.component';

import { AmlineComponent } from './quote/amline/amline.component';
import { AmQuoteViewComponent } from './quote/amline/am-quote-view/am-quote-view.component';
import { AmPolicyComponent } from './policy/amlin/am-policy/am-policy.component';

import { AgrimotorComponent } from './quote/agrimotor/agrimotor.component';
import { AgQuoteViewComponent } from './quote/agrimotor/ag-quote-view/ag-quote-view.component';
import { AgPolicyComponent } from './policy/agrimotor/ag-policy/ag-policy.component';
import { ReportComponent } from './policy/report/report.component';
import { AffinityComponent } from './affinity/affinity.component';
import { AffinityPartnerComponent } from './affinity-partner/affinity-partner.component';
import { AffinityPartnerUpsert } from './affinity-partner/affinity-partner-upsert';
import { AffinityPartnerUpsertComponent } from './affinity-partner/affinity-partner-upsert.component';
import { AmlinPaymentStatusImportComponent } from './policy/amlin/amlin-payment-status-import/amlin-payment-status-import.component';
import { BreakdownComponent } from './quote/breakdown/breakdown.component';
import { BreakdownQuoteViewComponent } from './quote/breakdown/breakdown-quote-view/breakdown-quote-view.component';
import { BreakdownPolicyComponent } from './policy/breakdown/breakdown-policy/breakdown-policy.component';


import { ExcessProtectComponent } from './quote/excess-protect/excess-protect.component';
import { ExcessProtectQuoteViewComponent } from './quote/excess-protect/excess-protect-quote-view/excess-protect-quote-view/excess-protect-quote-view.component';
import { ExcessProtectPolicyComponent } from './policy/excess-protect/excess-protect-policy/excess-protect-policy.component';


import { XspReportComponent } from './policy/excess-protect/xsp-report/xsp-report/xsp-report.component';
import { SdtkComponent } from './quote/sdtk/sdtk.component';
import {SdtkQuoteViewComponent} from './quote/sdtk/sdtk-quote-view/sdtk-quote-view/sdtk-quote-view.component';

import { SdtkPolicyComponent } from './policy/sdtk/sdtk-policy/sdtk-policy.component';
import { SdtkReportComponent } from './policy/sdtk/sdtk-report/sdtk-report.component';
import { EquineReportComponent } from './policy/equine/equine-report/equine-report.component';
import { EquineComponent } from './quote/equine/equine.component';
import { EquineQuoteViewComponent } from './quote/equine/equine-quote-view/equine-quote-view.component';
import { EquinePolicyComponent } from './policy/equine/equine-policy/equine-policy.component';

import { BreakdownReportComponent } from './policy/breakdown/breakdown-report/breakdown-report.component';

const appRoutes: Routes = [
  {
    path: '', component: LayoutLoginComponent,
    children: [
      { path: '', component: LoginComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'reset-password', component: ResetPasswordComponent }
    ]
  },
  {
    path: '', component: LayoutInnerpagesComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent, canActivate: [LoginGuard] },
      { path: 'dashboard-mi/:frequency', component: MiComponent, canActivate: [LoginGuard] },
      { path: 'company', component: CompanyComponent, canActivate: [LoginGuard] },
      { path: 'company-manage', component: CompanyUpsertComponent, canActivate: [LoginGuard] },
      { path: 'company-manage/:id', component: CompanyUpsertComponent, canActivate: [LoginGuard] },
      { path: 'user/:company_id/:id', component: UserComponent, canActivate: [LoginGuard] },
      { path: 'user-list/:company_id', component: UserListComponent, canActivate: [LoginGuard] },
      { path: 'user/:company_id', component: UserComponent, canActivate: [LoginGuard] },
      { path: 'pre-qualifier/:type', component: QuotePreQualifierComponent, canActivate: [LoginGuard] },
      { path: 'pre-qualifier/:type/:id', component: QuotePreQualifierComponent, canActivate: [LoginGuard] },
      { path: 'pre-qualifier/:type/:id/:quote_type', component: QuotePreQualifierComponent, canActivate: [LoginGuard] },
      { path: 'quote', component: QuoteComponent, canActivate: [LoginGuard] },
      { path: 'quote/:id', component: QuoteComponent, canActivate: [LoginGuard] },
      { path: 'quote/:id/:quote_type', component: QuoteComponent, canActivate: [LoginGuard] },
      { path: 'quote-list', component: QuoteListComponent, canActivate: [LoginGuard] },
      { path: 'quote-details/:quote_id', component: QuoteDetailsComponent, canActivate: [LoginGuard] },
      { path: 'policy-list', component: PolicyListComponent, canActivate: [LoginGuard] },
      { path: 'amlin-payment-status-import', component: AmlinPaymentStatusImportComponent, canActivate: [LoginGuard] },
      { path: 'policy/:quote_id', component: PolicyComponent, canActivate: [LoginGuard] },
      { path: 'bordereau', component: BordereauComponent, canActivate: [LoginGuard] },
      { path: 'live-policy-report', component: BordereauLiveComponent, canActivate: [LoginGuard] },
      { path: 'lapse-report', component: BordereauLapseComponent, canActivate: [LoginGuard] },
      { path: 'customer-report', component: ReportComponent, canActivate: [LoginGuard] },
      { path: 'affinity-report', component: AffinityComponent, canActivate: [LoginGuard] },
      { path: 'affinity-list', component: AffinityPartnerComponent, canActivate: [LoginGuard] },
      { path: 'affinity/:id', component: AffinityPartnerUpsertComponent, canActivate: [LoginGuard] },
      { path: 'affinity', component: AffinityPartnerUpsertComponent, canActivate: [LoginGuard] },
      { path: 'excess-protect-report', component: XspReportComponent, canActivate: [LoginGuard] },
      { path: 'sdtk-report', component: SdtkReportComponent, canActivate: [LoginGuard] },
      { path: 'equine-report', component: EquineReportComponent, canActivate: [LoginGuard] },
      { path: 'breakdown-report', component: BreakdownReportComponent, canActivate: [LoginGuard] },
    ]
  },
  {
    path: 'alpaca-admin', component: LayoutInnerpagesComponent,
    children: [
      { path: 'quote', component: AdminAlQuoteComponent },
      { path: 'quote/:quote_id', component: AdminAlQuoteComponent },
      { path: 'quote/:quote_id/:quote_type', component: AdminAlQuoteComponent },
      { path: 'quote-details/:quote_id', component: AlQuoteDetailsComponent },
      { path: 'policy/:quote_id', component: AlPolicyDetailsComponent }
    ]
  },
  {
    path: 'livestock', component: LayoutInnerpagesComponent,
    children: [
      { path: 'quote', component: LivestockComponent },
      { path: 'quote/:id', component: LivestockComponent },
      { path: 'quote/:id/:quote_type', component: LivestockComponent },
      { path: 'quote-details/:quote_id', component: LivestockViewComponent },
      { path: 'policy/:id', component: LivestockViewComponent },
      { path: 'lvpayment', component: LvPaymentConfirmationComponent },
    ]
  },
  {
    path: 'allianz-equine', component: LayoutInnerpagesComponent,
    children: [
      { path: 'quote', component: AllianzComponent },
      { path: 'quote/:id', component: AllianzComponent },
      { path: 'quote/:id/:quote_type', component: AllianzComponent },
      { path: 'quote-details/:quote_id', component: AllianzQuoteDetailsComponent },
      { path: 'policy/:quote_id', component: AllianzPolicyDetailsComponent },
    ]
  },
  {
    path: 'ajg', component: LayoutInnerpagesComponent,
    children: [
      { path: 'quote', component: AjgQuoteComponent },
      { path: 'quote/:id', component: AjgQuoteComponent },
      { path: 'quote/:id/:quote_type', component: AjgQuoteComponent },
      { path: 'quote-details/:quote_id', component: AjgQuoteViewComponent },
      { path: 'policy/:quote_id', component: PolicyViewComponent },
    ]
  },
  {
    path: 'amline', component: LayoutInnerpagesComponent,
    children: [
      { path: 'quote', component: AmlineComponent },
      { path: 'quote/:id', component: AmlineComponent },
      { path: 'quote/:id/:quote_type', component: AmlineComponent },
      { path: 'quote-details/:quote_id', component: AmQuoteViewComponent },
      { path: 'policy/:quote_id', component: AmPolicyComponent },
    ]
  },
  {
    path: 'breakdown', component: LayoutInnerpagesComponent,
    children: [
      { path: 'quote', component: BreakdownComponent },
      { path: 'quote/:id', component: BreakdownComponent },
      { path: 'quote/:id/:quote_type', component: BreakdownComponent },
      { path: 'quote-details/:quote_id', component: BreakdownQuoteViewComponent },
      { path: 'policy/:quote_id', component: BreakdownPolicyComponent },
    ]
  },
  {
    path: 'excess-protect', component: LayoutInnerpagesComponent,
    children: [
      { path: 'quote', component: ExcessProtectComponent },
      { path: 'quote/:id', component: ExcessProtectComponent },
      { path: 'quote/:id/:quote_type', component: ExcessProtectComponent },
      { path: 'quote-details/:quote_id', component: ExcessProtectQuoteViewComponent },
      { path: 'policy/:quote_id', component: ExcessProtectPolicyComponent },
    ]
  },
  {
    path: 'sdtk', component: LayoutInnerpagesComponent,
    children: [
      { path: 'quote', component: SdtkComponent },
      { path: 'quote/:id', component: SdtkComponent },
      { path: 'quote/:id/:quote_type', component: SdtkComponent },
      { path: 'quote-details/:quote_id', component: SdtkQuoteViewComponent },
      { path: 'policy/:quote_id', component: SdtkPolicyComponent },
    ]
  },
  {
    path: 'agrimotor', component: LayoutInnerpagesComponent,
    children: [
      { path: 'quote', component: AgrimotorComponent },
      { path: 'quote/:id', component: AgrimotorComponent },
      { path: 'quote/:id/:quote_type', component: AgrimotorComponent },
      { path: 'quote-details/:quote_id', component: AgQuoteViewComponent },
      { path: 'policy/:quote_id', component: AgPolicyComponent },
    ]
  },
  {
    path: 'equine', component: LayoutInnerpagesComponent,
    children: [
      { path: 'quote', component: EquineComponent },
      { path: 'quote/:id', component: EquineComponent },
      { path: 'quote/:id/:quote_type', component: EquineComponent },
      { path: 'quote-details/:quote_id', component: EquineQuoteViewComponent },
      { path: 'policy/:quote_id', component: EquinePolicyComponent },
    ]
  },
  {
    path: '', component: LayoutInnerpagesComponent,
    children: [
      { path: 'email-view/:id', component: QuoteEmailViewComponent },
      { path: 'unauthorized', component: UnauthorizedAccessComponent },
      { path: '**', component: PageNotFoundComponent }
    ]
  },

];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false }
    ),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
